// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Config del proyecto baked at build time. NO EDITAR.

export const APP_CONFIG = {
    name: "Unnamed",
    title: "Aprosuba_WEB",
    version: "29.04.2026.",
    tablePrefix: "gen",
    entryPoint: "EntradaApp",
    loginCollection: "LoginColl",
    autoLogon: false,
    apiBase: "/api/v1",
    projectId: "aprosuba_web",
    defaultLanguage: "javascript",
} as const;
